export const WORKFLOW = Object.freeze({
  INVITED: "invited",

  REGISTRATION_PENDING: "registration_pending",
  REGISTRATION_APPROVED: "registration_approved",

  PROFILE_COMPLETE: "profile_complete",

  DOCUMENT_UPLOAD: "document_upload",
  DOCUMENT_SUBMITTED: "document_submitted",

  REVIEW_QUEUE: "review_queue",
  ACTION_REQUIRED: "action_required",

  READY: "ready",
  ACTIVE: "active",

  ASSIGNED: "assigned",
  ACTIVATED: "activated",
  TRACKING: "tracking",
  ARRIVED: "arrived",
  COMPLETED: "completed",

  SUSPENDED: "suspended",
  ARCHIVED: "archived",
});

export const WORKER_TRANSITIONS = Object.freeze({
  INVITE_CREATED: "invite_created",
  REGISTRATION_SUBMITTED: "registration_submitted",
  REGISTRATION_APPROVED: "registration_approved",
  PROFILE_COMPLETED: "profile_completed",
  DOCUMENTS_UPLOADING: "documents_uploading",
  DOCUMENTS_SUBMITTED: "documents_submitted",
  REUPLOAD_REQUESTED: "reupload_requested",
  DOCUMENTS_APPROVED: "documents_approved",
  WORKER_APPROVED: "worker_approved",
  WORKER_SUSPENDED: "worker_suspended",
  WORKER_ARCHIVED: "worker_archived",
});